export const headTageTitle = (config: any) => {
  const headTags = config?.head_tags;
  const startTag = "<title>";
  const endTag = "</title>";
  if (headTags && headTags.includes(startTag) && headTags.includes(endTag)) {
    const startPosition = headTags?.indexOf(startTag) + startTag.length;
    const endPosition = headTags?.indexOf(endTag);
    return headTags.slice(startPosition, endPosition);
  }
};
